import React from 'react';
import { connect } from 'react-redux';

import {
    displayableCashback,
    getMerchantCardUrl,
    renderPluralConditional,
    isMultiDiscount,
    isMultiDiscountOffline,
    hasCashback,
    hasOffline,
    hasCashbackOffline,
    hasEbonCashback
} from '../../../services/partner/utils';

import { STATIC_ROOT } from '../../../constants';

import SvgComponent from '../../SvgComponent';
import LocalizedNavLink from '../../router/LocalizedNavLink';

const renderUpTo = (partner, UPTO, isOffline) =>
    partner &&
    ((!isOffline && isMultiDiscount(partner)) || (isOffline && isMultiDiscountOffline(partner)))
        ? UPTO
        : '';

const mapStateToPropsResultCashback = state => ({
    REFUND: state.i18n.feature.partenaire.rembourse,
    UPTO: state.i18n.feature.partenaire.jusqua
});
const ResultCashback = connect(mapStateToPropsResultCashback)(({ partner, REFUND, UPTO }) =>
    hasCashback(partner) ? (
        <div className="value">
            <SvgComponent src={`${STATIC_ROOT}/picto-en-ligne.svg`} width="11" height="11" />
            {renderUpTo(partner, UPTO)}&nbsp;
            <span>
                {displayableCashback(
                    partner.mostDisplayableDiscountOnline.percent,
                    partner.mostDisplayableDiscountOnline.fixed
                )}
            </span>
            &nbsp;
            {renderPluralConditional(
                REFUND,
                () =>
                    partner &&
                    (partner.mostDisplayableDiscountOnline.fixed > 1 ||
                        partner.mostDisplayableDiscountOnline.percent > 1)
            )}
        </div>
    ) : null
);
const ResultCashbackOffline = connect(mapStateToPropsResultCashback)(({ partner, REFUND, UPTO }) =>
    hasOffline(partner) && hasCashbackOffline(partner) ? (
        <div className="value">
            <SvgComponent src={`${STATIC_ROOT}/picto-magasin.svg`} width="13" height="14" />
            {renderUpTo(partner, UPTO, true)}&nbsp;
            <span>
                {displayableCashback(
                    partner.mostDisplayableDiscountOffline.percent,
                    partner.mostDisplayableDiscountOffline.fixed
                )}
            </span>
            &nbsp;
            {renderPluralConditional(
                REFUND,
                () =>
                    partner &&
                    (partner.mostDisplayableDiscountOffline.fixed > 1 ||
                        partner.mostDisplayableDiscountOffline.percent > 1)
            )}
        </div>
    ) : null
);
const ResultCashbackEbon = connect(mapStateToPropsResultCashback)(({ partner, REFUND }) =>
    hasEbonCashback(partner) ? (
        <div className="value">
            <SvgComponent src={`${STATIC_ROOT}/picto-ebon.svg`} width="17" height="15" />
            <span>
                {displayableCashback(
                    partner.ebonDiscount.cashback.percent.value,
                    partner.ebonDiscount.cashback.fixed.value
                )}
            </span>
            &nbsp;
            {renderPluralConditional(
                REFUND,
                () =>
                    partner &&
                    (partner.ebonDiscount.cashback.fixed.value > 1 ||
                        partner.ebonDiscount.cashback.fixed.value > 1)
            )}
        </div>
    ) : null
);

const ResultCodeReduction = ({ partner }) =>
    partner.couponCount > 0 && (
        <React.Fragment>
            <SvgComponent src={`${STATIC_ROOT}/code-promo.svg`} width="18" height="22" />
            {partner.couponCount}
        </React.Fragment>
    );

export const ResultComponent = ({ partner, onClick }) => (
    <li className={`resultat`}>
        {hasEbonCashback(partner) ? (
            <LocalizedNavLink to={getMerchantCardUrl(partner, false, true)} onClick={onClick}>
                <div className="resultat-conteneur flex-container-h flex-center-alt">
                    <div className="partnerName">{partner.name}</div>
                    <div className="resultat-valeur">
                        <ResultCashbackEbon partner={partner} />
                    </div>
                </div>
            </LocalizedNavLink>
        ) : hasOffline(partner) && hasCashbackOffline(partner) ? (
            <LocalizedNavLink to={getMerchantCardUrl(partner, true, false)} onClick={onClick}>
                <div className="resultat-conteneur flex-container-h flex-center-alt">
                    <div className="partnerName">{partner.name}</div>
                    <div className="resultat-valeur">
                        <ResultCashbackOffline partner={partner} />
                    </div>
                </div>
            </LocalizedNavLink>
        ) : (
            <LocalizedNavLink to={getMerchantCardUrl(partner, false, false)} onClick={onClick}>
                <div className="resultat-conteneur flex-container-h flex-center-alt">
                    <div className="partnerName">{partner.name}</div>
                    <div className="resultat-valeur">
                        {hasCashback(partner) && <ResultCashback partner={partner} />}
                    </div>
                    <div className="coupon">
                        {partner.couponCount > 0 && <ResultCodeReduction partner={partner} />}
                    </div>
                </div>
            </LocalizedNavLink>
        )}
    </li>
);



// WEBPACK FOOTER //
// ./src/components/header/search/ResultComponent.js